<div class="slider-box row d-block">
  <div class="sidebar-content">
    <div class="slide-logo gap-2 d-flex align-items-center">
      <div (click)="navigateToDashbaord()" class="cursor-pointer">
        <span><img src="/assets/images/logo-n.svg" alt="logo" /></span>
        <span class="sidebar-link">
          <img src="/assets/images/logo-nadel.svg" alt="logo" />
        </span>
      </div>
    </div>
    <div class="list-panel-box">
      <div *ngFor="let menu of sideBarMenuData">
        <li
          *ngIf="menu.isVisible && isValidRole(menu)"
          (click)="navigate(menu.url)"
          [ngClass]="{
            activenav: submenuStates.get(menu.title),
          }">
          <span
            class="d-flex link-pd align-items-center text-decoration-none justify-content-between"
            (click)="toggleSubmenu(menu); $event.stopPropagation()"
            (keydown.enter)="toggleSubmenu(menu); $event.stopPropagation()"
            (keydown.space)="toggleSubmenu(menu); $event.stopPropagation()"
            tabindex="0"
            role="button">
            <span class="d-flex">
              <span>
                <img
                  [src]="
                    !menu.iconExpanded
                      ? menu.iconCollapsed
                      : menu.isCollapsed
                        ? menu.iconCollapsed
                        : menu.iconExpanded
                  "
                  alt="logo" />
              </span>
              <span class="sidebar-link">{{ menu.title }}</span>
            </span>
            <span *ngIf="menu.child" class="nav-down-arrow-parent">
              <i class="pi pi-angle-right"></i>
            </span>
          </span>
          <ul
            class="m-0 subsidebar-link p-0"
            [ngClass]="{
              activenav: submenuStates.get(menu.title),
            }">
            <div *ngFor="let child of menu.child">
              <li
                *ngIf="isValidRole(child)"
                [ngClass]="{
                  subactive: child.isActivated,
                  activenavchild: submenuStates.get(child.title),
                }"
                tabindex="0"
                role="button">
                <span
                  class="d-flex link-pd align-items-center text-decoration-none justify-content-between subchild02-link"
                  (click)="toggleSubmenuChild(child); $event.stopPropagation()"
                  (keydown.enter)="
                    toggleSubmenuChild(child); $event.stopPropagation()
                  "
                  (keydown.space)="
                    toggleSubmenuChild(child); $event.stopPropagation()
                  "
                  tabindex="0"
                  role="button">
                  <span class="sidebar-link">{{ child.title }}</span>
                  <span *ngIf="child.subChild" class="nav-down-arrow">
                    <i class="pi pi-angle-right"></i>
                  </span>
                </span>

                <ul
                  *ngIf="submenuStates.get(child.title)"
                  class="m-0 p-0 subchild-link"
                  [ngClass]="{
                    activenav: submenuStates.get(child.title),
                  }">
                  <li *ngFor="let subChild of child.subChild">
                    <span
                      class="d-flex link-pd link-child subchild-arrow align-items-center text-decoration-none"
                      (click)="navigate(subChild.url)"
                      tabindex="0"
                      role="button">
                      <span class="sidebar-link">{{ subChild.title }}</span>
                    </span>
                  </li>
                </ul>
              </li>
            </div>
          </ul>
        </li>
        <div *ngIf="menu.divider" class="divider-bar mt-4 mb-4"></div>
      </div>
    </div>

    <div class="build-info">
      <small>{{ buildNumber }}</small>
    </div>
  </div>
</div>

<a
  (click)="toggleSidebar()"
  href="javascript:;"
  class="position-absolute arrow-slide p-1 justify-content-between d-flex justify-content-between align-items-center rounded-circle border pe-auto"
  tabindex="0"
  role="button">
  <i class="pi pi-angle-left"></i>
</a>
